import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { LL_V_L } from '@nu-art/thunderstorm-frontend/components/Layouts/Layouts';
import { Button, ComponentSync, TS_TextArea } from '@nu-art/thunderstorm-frontend/index';
import { arrayTrieGet, trieSuggest } from '@smikhalevski/trie';
import { filterInstances } from '@nu-art/ts-common';
import { ModuleFE_Dictionary } from '@app/hcs-frontend';
class PgComponent extends ComponentSync {
    deriveStateFromProps(nextProps, state) {
        const trieSuggestions = state.input ? trieSuggest(ModuleFE_Dictionary.trie, state.input) : undefined;
        state.suggestions = filterInstances(trieSuggestions?.map(suggest => suggest.key));
        return state;
    }
    doSomething = async () => {
        if (this.state.input)
            this.logWarning(this.getSpellCheckTypos(this.state.input));
    };
    render() {
        return _jsxs(LL_V_L, { children: [_jsx(TS_TextArea, { type: 'text', value: this.state.input, onChange: (value) => this.reDeriveState({ input: value }) }), this.renderButtons(), this.state.suggestions] });
    }
    renderButtons = () => {
        return _jsx(Button, { onClick: this.doSomething, children: "Do something" });
    };
    getSpellCheckTypos(origin) {
        const foundTypos = origin.split(/\b/).reduce((typos, word) => {
            if (arrayTrieGet(ModuleFE_Dictionary.arrayTrie, word)) // found in custom dictionary
                return typos;
            // if (!ModuleFE_Dictionary.spellchecker.check(word)) // didn't find in Hunspell dictionary
            // 	typos.push(word);
            return typos;
        }, []);
        return foundTypos;
    }
    // @ts-ignore
    getSpellCheckedString(origin) {
        return origin;
    }
}
export const PgDev_SpellCheckTest = {
    name: 'SpellCheck Test',
    key: 'spellcheck-test',
    renderer: PgComponent,
};
